// extracted by mini-css-extract-plugin
module.exports = {"header":"_2Us3tLEf","headerContent":"_30TdIoHB","arrow":"_1UuTWGEK","expandedArrow":"_3FrQZ6FZ"};